<nz-list nzItemLayout="horizontal" [nzLoading]="loading">
  <nz-list-item *ngFor="let item of notifications">
    <nz-alert nzType="info" [nzMessage]="item.notificationContent" [nzDescription]="item.createdAt | date" nzShowIcon nzIconType="bell"></nz-alert>
  </nz-list-item>
  <nz-list-empty *ngIf="notifications.length === 0"></nz-list-empty>
</nz-list>
<div style="display: flex; justify-content: center; margin-top: 5px;">
  <button nz-button [nzLoading]="loading" (click)="getNotifications()" *ngIf="haveMoreData">Load more notifications</button>
</div>
